import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Chip, Divider, Tooltip } from '@mui/material';
import PrivacyInfoBillingContent from '../PrivacyFormFolder/PrivacyInfoBillingContent';
import { SparkRadioGroup } from 'sharedComponents/SparkForm';
import { useBillingTypes } from 'hooks/Billing/useBillingTypes';
import { useSparkPrivacyTypes } from 'hooks/EntityTypes/useSparkPrivacyTypes';
import { useFormikContext } from 'formik';
import type { MainInfoFormType } from './MainInfoForm';
import SectionHeader from '../SparkSectionHeader';

const sparkPrivacyTypeIDs = {
  PUBLIC: '3',
};

function SparkPrivacyDetails() {
  const navigate = useNavigate();
  const {
    values: { sparkPrivacyTypeID },
  } = useFormikContext<MainInfoFormType>();
  const [isPublicSpark, setIsPublicSpark] = React.useState<boolean>(
    sparkPrivacyTypeID === sparkPrivacyTypeIDs.PUBLIC
  );

  const {
    dropdownOptions: privacyTypeOptions,
    sparkPrivacyTypeIdByNameMap,
    isLoading: isLoadingPrivacyTypes,
    sparkPrivacyTypes: privacyTypesData,
  } = useSparkPrivacyTypes();

  const { dropdownOptions: billingOptions, isLoading: isLoadingBillingTypes } =
    useBillingTypes();

  const handlePrivacyChange = (value: string) => {
    const isPublic = value === sparkPrivacyTypeIdByNameMap?.['Public'];
    setIsPublicSpark(isPublic);
  };

  const getDisabledEntity = () =>
    privacyTypesData?.filter(
      (type) => type?.meta?.user?.usageRights?.restricted === true
    ) ?? [];

  const privacyTypeMetaData =
    getDisabledEntity()[0]?.meta?.user?.usageRights?.toolTip;

  const handleCtaLinkClick = () => {
    if (!!privacyTypeMetaData.ctaRoute) {
      navigate(privacyTypeMetaData.ctaRoute);
      return;
    }
    window.open(privacyTypeMetaData.ctaLink);
  };

  if (isLoadingPrivacyTypes || isLoadingBillingTypes) {
    return <>Loading</>;
  }

  return (
    <>
      <Box display='flex' flexDirection='column' width='100%'>
        <Divider sx={{ marginBottom: '20px', marginTop: '20px' }} />
        <SectionHeader headerText='Privacy' marginBottom={0} />
        <SparkRadioGroup
          name='sparkPrivacyTypeID'
          options={privacyTypeOptions || []}
          onChange={handlePrivacyChange}
          disabledEntities={[
            {
              value: getDisabledEntity()[0]?.id,
              helperComponent: (
                <Tooltip
                  title={
                    <div>
                      {privacyTypeMetaData?.title}
                      <br />
                      {privacyTypeMetaData?.message}
                    </div>
                  }
                >
                  <Chip
                    size='small'
                    sx={{
                      color: privacyTypeMetaData?.fontColor,
                      backgroundColor: privacyTypeMetaData?.backgroundFillColor,
                    }}
                    icon={
                      <Avatar
                        alt='lockIcon'
                        src={privacyTypeMetaData?.iconURL}
                        sx={{ width: 13.33, height: 15 }}
                      />
                    }
                    label={privacyTypeMetaData?.ctaLabel}
                    onClick={handleCtaLinkClick}
                  />
                </Tooltip>
              ),
            },
          ]}
        />
      </Box>
      <PrivacyInfoBillingContent
        isPublicSpark={isPublicSpark}
        billingOptions={billingOptions}
      />
    </>
  );
}

export default SparkPrivacyDetails;
